export const BRIGHTCOVE = 'brightcove';
export const YOUTUBE = 'youtube';
